export const defaultSessionOptions = {
    stickySession: true,
    minReplayDuration: 3000,
    networkDetailAllowUrls: [window.location.origin],
    networkResponseHeaders: ['x-prism-trace-id'],
    networkCaptureBodies: true,
    beforeAddRecordingEvent: (event) => {
        const returnEvent = event;
        if (event.data.tag === 'performanceSpan' &&
            (event.data.payload.op === 'resource.fetch' ||
                event.data.payload.op === 'resource.xhr') &&
            event.data.payload.data?.response?.body?.error) {
            returnEvent.data.payload.data.response.body = {
                error: event.data.payload.data.response.body.error,
            };
        }
        else {
            returnEvent.data.payload.data.response.body = null;
        }
        return returnEvent;
    },
};
export const unmaskedSessionOptions = {
    maskAllText: false,
    maskAllInputs: false,
    blockAllMedia: false,
    beforeAddRecordingEvent: null,
};
//# sourceMappingURL=sentry.util.js.map